import { render, staticRenderFns } from "./WordleCTA.vue?vue&type=template&id=e3f8bd1c&scoped=true&"
import script from "./WordleCTA.vue?vue&type=script&lang=js&"
export * from "./WordleCTA.vue?vue&type=script&lang=js&"
import style0 from "./WordleCTA.vue?vue&type=style&index=0&id=e3f8bd1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f8bd1c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HybridLink: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/HybridLink/HybridLink.vue').default})
